
import { Actions, ActionTypes } from '@appStore/products/actions';
import { ServiceAgreement, ServiceAgreementFilterSettings, ServiceAgreementInformation } from '@model';

export interface State {
    data: ServiceAgreement[]
    loading: boolean;
    loaded: boolean;
    selected: ServiceAgreementInformation;

    serviceAgreementsFilter: ServiceAgreementFilterSettings;
    selectedTabIndexServiceAgreements: number;
}

export const initialState: State = {
    data: [],
    loading: false,
    loaded: false,
    selected: null,

    serviceAgreementsFilter: null,
    selectedTabIndexServiceAgreements: 0
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.ServiceAgreementsLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.ServiceAgreementsLoadSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload
      };

    case ActionTypes.ServiceAgreementsLoadFail:
      return { ...state, loaded: false, loading: false };

    // Filter
    case ActionTypes.ServiceAgreementsFilterSaveData:
      return { ...state, serviceAgreementsFilter: action.payload };  

    case ActionTypes.SelectTabIndexServiceAgreements:
      return {...state, selectedTabIndexServiceAgreements: action.payload };

    case ActionTypes.SelectServiceAgreement:
        return {...state, selected: action.payload };    
    case ActionTypes.SelectServiceAgreementById:
      let sai = null;
      state.data.forEach(e => {
        e.serviceAgreementInformation.forEach(sa => {
          if (sa.agreementId === action.payload) {
            sai = {...sa,
              customerId: e.customerId
            }; 
          }
        });
      });
      return { ...state, selected: sai }; 
  }
  return state;
}

export const getServiceAgreementsLoaded = (state: State) => state.loaded;
export const getServiceAgreements = (state: State) => state.data;
export const getServiceAgreementsFilter = (state: State) => state.serviceAgreementsFilter;
export const getSelectedTabIndexServiceAgreements = (state: State) => state.selectedTabIndexServiceAgreements;
export const getSelectedServiceAgreement = (state: State) => state.selected;
export const getServiceAgreementsFilterSettings = (state: State) => state.serviceAgreementsFilter;
  